import { SIMCARD_PATH } from 'devices/navigation';

module.exports = {
  path: SIMCARD_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceSimcard'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/devices/routes/show/routes/simcard/index.js